import {axiosInstance} from "./base";

export const clearAllSessions = () => axiosInstance.delete(`/api/v1/user/sessions`);
